import { render, staticRenderFns } from "./ShareTM.vue?vue&type=template&id=69975a74&"
import script from "./ShareTM.vue?vue&type=script&lang=js&"
export * from "./ShareTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports